export default __webpack_public_path__ + "static/media/como_funciona_02.c95ddde5.png";